import { render, staticRenderFns } from "./batch_freight_edit.vue?vue&type=template&id=6ce127b2&scoped=true&"
import script from "./batch_freight_edit.vue?vue&type=script&lang=js&"
export * from "./batch_freight_edit.vue?vue&type=script&lang=js&"
import style0 from "./batch_freight_edit.vue?vue&type=style&index=0&id=6ce127b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce127b2",
  null
  
)

export default component.exports